import IMCategoryDeleteModal from './IMCategoryDeleteModal';

export default IMCategoryDeleteModal;
